/**
 * Notification component for offcanvas view
 * 
 * Properties:
 * 
 *      message:            string, message to be displayed
 *      onCloseHandler:     function, callback for on closing
 */

import React from "react";
// @ts-ignore
import t from '../helpers/t';
import Link from "./Link";
// @ts-ignore
import Biscuit from '../../utils/Biscuit';

type Props = {
    link?: string,
    message?: string,
    linkHandler?: any,
    linkContent?: string,
    onCloseHandler?: any
}
const Notification = (props:Props) => {
    let link = "";
    if(typeof props.link !== 'undefined'){
        link = props.link;
    }
    console.log(props);
  return (
    <>
        <div className="off-canvas-form-overlay"></div>
        <div className="inb-message-box">
            <p>{props.message} {typeof props.link !== 'undefined' && props.link !== '' &&
                <Link
                    link={link}
                    linkHandler={props.linkHandler}
                    linkContent={(typeof props.linkContent !== 'undefined'?props.linkContent:'')}/>}</p>
            <div className="button-container">
                <button
                className={"button medium beautify beautify-" + Biscuit.get('user.client_id') + " round"}
                onClick={props.onCloseHandler}
                >
                    <span>
                        {t('ok')}
                    </span>
                </button>
            </div>
        </div>
        
    </>
  );
};
export default Notification;